import { useEffect, useRef, useState } from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import Button from '@modul-connect/shared/components/atoms/button/button.v2'
import Info from '@modul-connect/shared/img/info2.svg'
export const DisturbanceBanner = ({ open, title, description, onHeightChange }) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const rootRef = useRef(null)

  useEffect(() => {
    if (open) setIsExpanded(true)
  }, [open])

  useEffect(() => {
    const el = rootRef.current
    if (!el || typeof onHeightChange !== 'function') return
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        onHeightChange(entry.contentRect.height + 18)
      }
    })
    observer.observe(el)
    return () => {
      observer.disconnect()
      onHeightChange(0)
    }
  }, [onHeightChange])

  return (
    <View innerRef={rootRef} extend={bannerStyles.expanded}>
      <View extend={bannerStyles.innerColumn}>

        {isExpanded ? (
          <>
            <View extend={bannerStyles.closeRow} onClick={() => setIsExpanded(false)}>
              <View>Hide Information</View>
              <Button
                icon="Close"
                color="transparent"
                extend={bannerStyles.closeButton}
              />
            </View>
            <View extend={bannerStyles.contentColumn}>
              <View extend={bannerStyles.titleRow}>
                <View extend={bannerStyles.iconWrap}>
                  <img
                    src={Info}
                    alt="Info"
                    style={{ width: 16, height: 16 }}
                  />
                </View>
                <View extend={bannerStyles.titleText}>
                  {title}
                </View>
              </View>
              <View extend={bannerStyles.messageText}>
                {description}
              </View>
            </View>
          </>
        ) : (
          <View
            extend={bannerStyles.collapsedRow}
            onClick={() => setIsExpanded(true)}
          >
            <img
              src={Info}
              alt="Info"
              style={{ width: 16, height: 16 }}
            />
            <View extend={bannerStyles.collapsedText}>
              View important information
            </View>
          </View>
        )}

      </View>
    </View>
  )
}
const bannerStyles = {
  expanded: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '9px 24px',
    width: '100%',
    background: '#F9E801'
  },

  innerColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  closeRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    height: 24,
    gap: 10,
    cursor: 'pointer'
  },

  closeButton: {
    fontSize: 14,
    padding: 0
  },

  contentColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0 340px 24px 370px',
    gap: 14,
  },

  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },

  iconWrap: {
    width: 20,
    height: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },

  titleText: {
    fontWeight: 500,
    fontSize: 18,
  },

  messageText: {
    width: '100%',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '19px',
    paddingLeft: 30,
  },

  collapsedRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    justifyContent: 'flex-end'
  },

  collapsedText: {
    fontSize: 14,
    fontWeight: 500,
  },
}